(function () {
  const initMainSlider = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const sliderEl = section.querySelector(".js-media-list");
    if (!sliderEl) return;

    const desktopType = sliderEl.dataset?.desktopType || "slider";
    const mobileType = sliderEl.dataset?.mobileType || "slider";
    const hasDesktopZoom = sliderEl.dataset?.hasDesktopZoom === "true";
    // const navPrev = sliderEl.querySelector(".swiper-button-prev");
    // const navNext = sliderEl.querySelector(".swiper-button-next");
    const mediaBox = sliderEl.closest(".product__media");
    const thumbsSlider = mediaBox?.querySelector(".js-media-sublist");

    // const isLoop = sliderEl.querySelectorAll(".swiper-slide").length > 2;

    const initSwiper = () => {
      if (sliderEl.swiper && !sliderEl.swiper.destroyed) {
        return sliderEl.swiper;
      }

      return new Swiper(sliderEl, {
        // slidesPerView: mobileType === "slider" ? "auto" : 1,
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        loop: false,
        direction: "horizontal",
        speed: 800,
        allowTouchMove: true,
        watchSlidesProgress: true,
        mousewheel: {
          forceToAxis: true,
        },
        pagination: {
          el: section.querySelector(
            ".product__media-wrapper .swiper-pagination"
          ),
          type: "progressbar",
        },
        // navigation: {
        //   nextEl: navNext,
        //   prevEl: navPrev,
        // },
        breakpoints: {
          990: {
            direction: "vertical",
            slidesPerView: desktopType === "slider" ? "auto" : 1,
            allowTouchMove: !hasDesktopZoom,
          },
        },
        thumbs: {
          swiper: thumbsSlider?.swiper ? thumbsSlider.swiper : "",
        },
        on: {
          // resize(swiper) {
          //   if (window.innerWidth >= 990) {
          //     swiper.el.setAttribute("dir", "ltr");
          //   } else {
          //     swiper.el.setAttribute("dir", "rtl");
          //   }
          // },
          slideChange: function () {
            //window.pauseAllMedia();
            window.pauseAllModels();
            this.params.noSwiping = false;
          },
          slideChangeTransitionEnd: function () {
            const activeIndex = this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            const posterBtn3D = this.slides[activeIndex]?.querySelector(
              ".shopify-model-viewer-ui__button--poster"
            );
            if (model3D && posterBtn3D) {
              posterBtn3D.removeAttribute("hidden");
            }
          },
          touchStart: function () {
            const activeIndex = this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            if (model3D) {
              if (
                !model3D.classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });
    };

    const destroySwiper = () => {
      if (sliderEl.swiper) {
        sliderEl.swiper.destroy();
      }
      sliderEl.querySelectorAll(".swiper-wrapper").forEach((wrapper) => {
        wrapper.removeAttribute("style");
      });
      sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
        slide.removeAttribute("style");
      });
    };

    const hasDesktopSwiper =
      desktopType === "slider" || desktopType == "slider_previews";
    const hasMobileSwiper =
      mobileType === "slider" || mobileType == "slider_previews";

    if (hasDesktopSwiper && hasMobileSwiper) {
      initSwiper();
    } else {
      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (window.innerWidth >= 990 && hasDesktopSwiper) {
            initSwiper();
            return;
          }

          if (window.innerWidth < 990 && hasMobileSwiper) {
            initSwiper();
            return;
          }

          destroySwiper();
        });
      });

      resizeObserver.observe(section);
    }
  };

  const initSubSlider = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const sliderEl = section.querySelector(".js-media-sublist");
    if (!sliderEl) return;

    const desktopType = sliderEl.dataset?.desktopType || "slider";
    const mobileType = sliderEl.dataset?.mobileType || "slider";
    const hasDesktopSwiper = desktopType === "slider_previews";
    const hasMobileSwiper = mobileType === "slider_previews";

    const slidesCount = sliderEl.querySelectorAll(
      ".product__media-subitem"
    ).length;

    const syncThumbsTouchState = (swiper) => {
      if (!swiper || swiper.destroyed) return;

      if (swiper.isHorizontal()) {
        swiper.params.allowTouchMove = true;
        swiper.allowTouchMove = true;
        return;
      }

      const slides = Array.from(swiper.slides || []);
      if (!slides.length) return;

      const firstSlide = slides[0];
      const lastSlide = slides[slides.length - 1];
      const contentHeight =
        lastSlide.offsetTop + lastSlide.offsetHeight - firstSlide.offsetTop;
      const hasOverflow = contentHeight > swiper.el.clientHeight + 1;

      swiper.params.allowTouchMove = hasOverflow;
      swiper.allowTouchMove = hasOverflow;

      if (!hasOverflow && swiper.translate !== 0) {
        swiper.setTranslate(0);
        swiper.updateProgress(0);
      }
    };

    const initSwiper = () => {
      const thumbSlider = new Swiper(sliderEl, {
        spaceBetween: 2,
        // distortion: 枚数が多い時は次の1枚を半分見切らせて続きがあると分かるように
        slidesPerView: slidesCount > 4 ? 4.5 : slidesCount,
        loop: false,
        direction: "horizontal",
        allowTouchMove: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        autoHeight: false,
        slideToClickedSlide: true,
        on: {
          afterInit: syncThumbsTouchState,
          breakpoint: syncThumbsTouchState,
          resize: syncThumbsTouchState,
          observerUpdate: syncThumbsTouchState,
          touchEnd: function (swiper) {
            syncThumbsTouchState(swiper);

            let range = 5;
            let diff = (swiper.touches.diff = swiper.isHorizontal()
              ? swiper.touches.currentX - swiper.touches.startX
              : swiper.touches.currentY - swiper.touches.startY);
            if (Math.abs(diff) < range) swiper.allowClick = true;
          },

          click: function (swiper) {
            if (
              window.innerWidth < 990 ||
              !hasDesktopSwiper ||
              !swiper.clickedSlide ||
              !swiper.allowClick
            )
              return;

            const clickedSlide = swiper.clickedSlide;
            const realIndex = parseInt(
              clickedSlide.dataset.swiperSlideIndex ??
                swiper.clickedIndex
            );

            const translateY = swiper.translate;
            const slideTop = clickedSlide.offsetTop;
            const slideBottom = slideTop + clickedSlide.offsetHeight;
            const visibleTop = -translateY;
            const visibleBottom = visibleTop + swiper.height;

            if (slideTop >= visibleTop && slideBottom <= visibleBottom) {
              if (swiper.thumbs && swiper.thumbs.swiper) {
                swiper.thumbs.swiper.slideTo(realIndex, 0, false);
              }
              swiper.activeIndex = realIndex;
              swiper.updateSlidesClasses();
              swiper.emit('slideChange');
            } else {
              swiper.slideToLoop(realIndex);
            }
          },
        },
        breakpoints: {
          576: {
            slidesPerView: slidesCount > 6 ? 6.5 : slidesCount,
          },
          990: {
            slidesPerView: "auto",
            direction: "vertical",
          },
        },
      });

      return thumbSlider;
    };

    if (hasDesktopSwiper || hasMobileSwiper) {
      initSwiper();

      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (sliderEl.swiper) {
            if (window.innerWidth >= 990 && hasDesktopSwiper) {
              sliderEl.swiper.enable();
              sliderEl.swiper.changeDirection("vertical", true);
              syncThumbsTouchState(sliderEl.swiper);
            }

            if (
              window.innerWidth >= 990 &&
              desktopType === "stacked_previews"
            ) {
              sliderEl.swiper.disable();
            }

            if (window.innerWidth < 990 && hasMobileSwiper) {
              sliderEl.swiper.enable();
              sliderEl.swiper.changeDirection("horizontal", true);
              syncThumbsTouchState(sliderEl.swiper);
            }
          }
        });
      });

      resizeObserver.observe(section);
    }
  };

  // distortion: PCではメイン画像（正方形）の幅を右カラムの高さに合わせて、左右の高さを揃える
  const syncMediaToInfoHeight = (section) => {
    if (!section || !section.classList.contains("product-section")) return;
    const info = section.querySelector(".product__info-container");
    const listWrapper = section.querySelector(".product__media-list-wrapper");
    if (!info || !listWrapper) return;

    const apply = () => {
      if (window.innerWidth >= 990) {
        const h = info.offsetHeight;
        if (h > 300) listWrapper.style.maxWidth = h + "px";
      } else {
        listWrapper.style.maxWidth = "";
      }
      // メイン画像の高さが変わるためサムネ列の高さも追従させる
      setTimeout(() => initHeights(section), 50);
    };

    apply();
    if (!listWrapper.dataset.rnSyncBound) {
      listWrapper.dataset.rnSyncBound = "1";
      new ResizeObserver(() => {
        const current = parseInt(listWrapper.style.maxWidth) || 0;
        if (window.innerWidth >= 990 && Math.abs(info.offsetHeight - current) > 2) apply();
        if (window.innerWidth < 990 && listWrapper.style.maxWidth) apply();
      }).observe(info);
      window.addEventListener("resize", apply);
    }
  };

  const initHeights = (section) => {
    const mainSlider = section.querySelector(".swiper-wrapper");

    if (!mainSlider) return;

    const height = `${mainSlider.offsetHeight}px`;
    const pagination = section.querySelector(".swiper-pagination");
    const subSliderParent =
      section.querySelector(".js-media-sublist")?.parentNode;

    if (pagination) pagination.style.height = height;
    if (subSliderParent) subSliderParent.style.height = height;
  };

  const initZoomSlider = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const sectionBox = section.querySelector('[id^="MainProduct-"]');
    const sectionId = sectionBox?.dataset?.section;
    const sliderEl = document.querySelector(
      `[data-section-id='${sectionId}'].js-popup-slider`
    );
    if (!sliderEl) return;

    const buttonPrev = sliderEl.querySelector(".swiper-button-prev");
    const buttonNext = sliderEl.querySelector(".swiper-button-next");

    const onMainSliderToggleClick = (event) => {
      if (!sliderEl.swiper) return;
      const zoomToggle = event.target.closest(".product__media-toggle");
      if (!zoomToggle) return;
      const mediaId = zoomToggle.dataset?.mediaId;
      if (!mediaId) return;
      sliderEl
        .querySelectorAll(".product-media-modal__item.swiper-slide")
        .forEach((slide, index) => {
          const zoomImageEl = slide.querySelector(
            `[data-media-id="${mediaId}"]`
          );
          if (zoomImageEl) {
            const slideIndex = Number(slide.dataset?.swiperSlideIndex || index);
            sliderEl.swiper.slideTo(slideIndex, 0);
            sliderEl.swiper.update();
          }
        });
    };

    new Swiper(sliderEl, {
      slidesPerView: 1,
      speed: 800,
      loop: false,
      zoom: {
        maxRatio: 2,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      on: {
        afterInit: function () {
          section
            .querySelectorAll(".product__media-list .product__media-toggle")
            .forEach((elem) => {
              elem.addEventListener("click", onMainSliderToggleClick);
            });
        },
        slideChange: function () {
          //window.pauseAllMedia();
          window.pauseAllModels();
          this.params.noSwiping = false;
          sliderEl.classList.remove("zoom");
        },
        touchMove: function () {
          sliderEl.classList.remove("zoom");
        },
        slideChangeTransitionEnd: function () {
          const activeIndex = this.activeIndex;
          const model3D =
            this.slides[activeIndex]?.querySelector("model-viewer");
          const posterBtn3D = this.slides[activeIndex]?.querySelector(
            ".shopify-model-viewer-ui__button--poster"
          );
          if (model3D && posterBtn3D) {
            posterBtn3D.removeAttribute("hidden");
          }
        },
        touchStart: function () {
          const activeIndex = this.activeIndex;
          const model3D =
            this.slides[activeIndex]?.querySelector("model-viewer");
          if (model3D) {
            if (
              !model3D.classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });
  };

  const initStackedPreviews = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const mediaList = section.querySelector(
      ".product__media-list[data-desktop-type='stacked_previews']"
    );
    const thumbs = section.querySelector(
      ".product__media-sublist[data-desktop-type='stacked_previews']"
    );
    if (!mediaList || !thumbs) return;

    const mediaEls = Array.from(mediaList.querySelectorAll("[data-media-id]"));
    const thumbEls = Array.from(thumbs.querySelectorAll("[data-media-sub-id]"));

    const setActiveThumb = (mediaId) => {
      thumbEls.forEach((thumb) => {
        thumb.classList.toggle("active", thumb.dataset.mediaSubId === mediaId);
      });

      const activeThumb = thumbs.querySelector(
        `[data-media-sub-id="${mediaId}"]`
      );
      if (!activeThumb) return;
      const thumbHeight = activeThumb.offsetHeight;
      const activeIndex = thumbEls.findIndex(
        (el) => el.dataset.mediaSubId === mediaId
      );

      const nextIndex = Math.min(activeIndex + 1, thumbEls.length - 1);

      const scrollTarget =
        thumbEls[nextIndex].offsetTop - thumbs.clientHeight / 2 + thumbHeight;

      thumbs.scrollTo({
        top: scrollTarget,
        behavior: "smooth",
      });
    };

    const onScroll = () => {
      if (window.innerWidth < 990) return;
      const viewportMiddle = window.scrollY + window.innerHeight / 2;

      let closestMedia = null;
      let closestDistance = Infinity;

      for (const mediaEl of mediaEls) {
        const rect = mediaEl.getBoundingClientRect();
        const mediaTop = window.scrollY + rect.top;
        const distance = Math.abs(mediaTop - viewportMiddle);

        if (mediaTop < viewportMiddle && distance < closestDistance) {
          closestDistance = distance;
          closestMedia = mediaEl;
        }
      }

      if (closestMedia) {
        setActiveThumb(closestMedia.dataset.mediaId);
      }
    };

    requestAnimationFrame(() => {
      onScroll();
    });

    window.addEventListener("scroll", onScroll, { passive: true });

    thumbEls.forEach((thumb) => {
      thumb.addEventListener("click", (e) => {
        if (window.innerWidth < 990) return;
        const mediaId = thumb.dataset.mediaSubId;
        const targetMedia = mediaList.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (targetMedia) {
          const offset =
            targetMedia.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: offset - 100, behavior: "smooth" });
          setActiveThumb(mediaId);
        }
      });
    });
  };

  const initProductAccordion = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const accordions = section.querySelectorAll(".product-accordion");

    accordions.forEach((accordion) => {
      accordion.addEventListener("click", (event) => {
        const toggleEl = event.target.closest(".product-accordion__toggle");
        if (!toggleEl) return;

        const contentEl = toggleEl.nextElementSibling;
        if (
          !contentEl ||
          !contentEl.classList.contains("product-accordion__content")
        ) {
          return;
        }

        const isActive = toggleEl.classList.contains("active");
        if (!isActive) {
          slideDown(toggleEl, contentEl, 300); // func in global.js
        } else {
          slideUp(toggleEl, contentEl, 300); // func in global.js
        }
      });
    });
  };

  const initStickyAddBar = (section) => {
    if (!section || !section.classList.contains("product-section")) return;

    const buyButtons = section.querySelector(
      ".product__buy-buttons > product-form"
    );
    const stickyBar = section.querySelector(".product-sticky-add-bar");
    const footerBottom = document.querySelector(
      ".shopify-section-group-footer-group .footer-bottom"
    );

    if (!stickyBar) return;

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.01,
    };

    const isElementBelowScroll = (element) => {
      return element ? element.getBoundingClientRect().top > 0 : false;
    };

    const toggleStickyBar = (isVisible) => {
      if (isVisible || isElementBelowScroll(buyButtons)) {
        stickyBar.classList.remove("active");
      } else {
        stickyBar.classList.add("active");
      }
    };

    const handleIntersect = (entries) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      toggleStickyBar(isVisible);
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (buyButtons) observer.observe(buyButtons);
    if (footerBottom) observer.observe(footerBottom);
  };

  let isZoomCursorInit = false;
  const initZoomCursor = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const mediaWrapper = section.querySelector(".product__media-list");
    const hasZoom =
      mediaWrapper.getAttribute("data-has-desktop-zoom") === "true";
    if (!hasZoom) return;

    const cursorEl = section.querySelector(".product__media-cursor");
    if (!cursorEl) return;

    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;
    const easingFactor = 0.2;
    let isAnimating = false;

    const animateCursor = () => {
      isAnimating = true;

      currentX += (targetX - currentX) * easingFactor;
      currentY += (targetY - currentY) * easingFactor;

      cursorEl.style.left = `${currentX}px`;
      cursorEl.style.top = `${currentY}px`;

      if (
        Math.abs(targetX - currentX) > 0.1 ||
        Math.abs(targetY - currentY) > 0.1
      ) {
        requestAnimationFrame(() => animateCursor());
      } else {
        isAnimating = false;
      }
    };

    const handleMouseMove = (e) => {
      if (!e.target.closest(".product__media-toggle")) {
        mediaWrapper.classList.remove("cursor-active");
      } else {
        mediaWrapper.classList.add("cursor-active");
      }

      const wrapperRect = mediaWrapper.getBoundingClientRect();
      const cursorRect = cursorEl.getBoundingClientRect();

      targetX = e.clientX - wrapperRect.left - cursorRect.width / 2;
      targetY = e.clientY - wrapperRect.top - cursorRect.height / 2;

      if (!isAnimating) {
        animateCursor();
      }
    };

    const handleMouseEnter = (e) => {
      const wrapperRect = mediaWrapper.getBoundingClientRect();
      const cursorRect = cursorEl.getBoundingClientRect();

      targetX = currentX = e.clientX - wrapperRect.left - cursorRect.width / 2;
      targetY = currentY = e.clientY - wrapperRect.top - cursorRect.height / 2;

      cursorEl.style.left = `${currentX}px`;
      cursorEl.style.top = `${currentY}px`;

      mediaWrapper.classList.add("cursor-active");
    };

    const handleMouseLeave = () => {
      mediaWrapper.classList.remove("cursor-active");
    };

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.contentRect.width >= 990 &&
          window.matchMedia("screen and (hover: hover) and (pointer: fine)")
            .matches
        ) {
          if (isZoomCursorInit) return;
          mediaWrapper.addEventListener("mouseenter", handleMouseEnter);
          mediaWrapper.addEventListener("mousemove", handleMouseMove);
          mediaWrapper.addEventListener("mouseleave", handleMouseLeave);

          isZoomCursorInit = true;
        } else {
          if (!isZoomCursorInit) return;
          mediaWrapper.removeEventListener("mouseenter", handleMouseEnter);
          mediaWrapper.removeEventListener("mousemove", handleMouseMove);
          mediaWrapper.removeEventListener("mouseleave", handleMouseLeave);

          isZoomCursorInit = false;
        }
      });
    });

    resizeObserver.observe(section);
  };

  const initTabs = (section) => {
    document.addEventListener("DOMContentLoaded", function () {
      section.querySelectorAll(".product__info-tabs").forEach((tabsWrapper) => {
        const tabs = tabsWrapper.querySelectorAll(".product__info-tabs-tab");
        const panels = tabsWrapper.querySelectorAll(
          ".product__info-tabs-panel"
        );

        tabs.forEach((tab) => {
          tab.addEventListener("click", () => {
            const target = tab.dataset.tab;

            tabs.forEach((t) => t.classList.remove("active"));
            panels.forEach((p) => p.classList.remove("active"));

            tab.classList.add("active");
            tabsWrapper
              .querySelector(`[data-tab-content="${target}"]`)
              .classList.add("active");
          });
        });
      });
    });
  };

  const initPagination = (section) => {
    const fill = section.querySelector(".swiper-pagination-progressbar-fill");

    if (!fill) return;

    const slides = [...section.querySelectorAll(".product__media-item")];

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleSlides = entries
          .filter((e) => e.isIntersecting)
          .map((e) => slides.indexOf(e.target));

        if (!visibleSlides.length) return;

        const current = Math.max(...visibleSlides);
        const progress = (current + 1) / slides.length;

        fill.style.transform = `scaleY(${progress})`;
      },
      { threshold: 0.6 }
    );

    slides.forEach((slide) => observer.observe(slide));
  };

  initSubSlider(document.currentScript.parentElement);
  initMainSlider(document.currentScript.parentElement);
  initHeights(document.currentScript.parentElement);
  syncMediaToInfoHeight(document.currentScript.parentElement);
  initZoomSlider(document.currentScript.parentElement);
  initStackedPreviews(document.currentScript.parentElement);

  initStickyAddBar(document.currentScript.parentElement);
  initZoomCursor(document.currentScript.parentElement);
  initProductAccordion(document.currentScript.parentElement);

  initTabs(document.currentScript.parentElement);
  initPagination(document.currentScript.parentElement);

  const section = document.currentScript.parentElement;

  window.addEventListener("scroll", () => initPagination(section));
  window.addEventListener("resize", () => initPagination(section));
  window.addEventListener("resize", () =>
    setTimeout(() => {
      initHeights(section);
    }, 100)
  );

  document.addEventListener("shopify:section:load", (event) => {
    initSubSlider(event.target);
    initMainSlider(event.target);
    initHeights(event.target);
    syncMediaToInfoHeight(event.target);
    initZoomSlider(event.target);
    initStackedPreviews(event.target);

    initStickyAddBar(event.target);
    initZoomCursor(event.target);
    if (!window.Shopify.designMode) {
      initProductAccordion(event.target);
    }
  });
})();
